import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import FocusRing from '@atlaskit/focus-ring';
import { varDotsMargin, varDotsSize } from './constants';
const commonStyles = css({
  width: `var(${varDotsSize})`,
  height: `var(${varDotsSize})`,
  position: 'relative',
  borderRadius: '50%',
  '&::before': {
    display: 'block',
    width: `calc(var(${varDotsSize}) + var(${varDotsMargin}))`,
    height: `calc(var(${varDotsSize}) + var(${varDotsMargin}))`,
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    top: `calc(-1 * var(${varDotsMargin}) / 2)`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    left: `calc(-1 * var(${varDotsMargin}) / 2)`,
    content: '""'
  }
});
const buttonStyles = css({
  padding: "var(--ds-space-0, 0px)",
  border: 0,
  cursor: 'pointer',
  outline: 0
});

/**
 * __Presentational indicator__
 *
 * A presentational indicator with no interactivity
 */
export const PresentationalIndicator = (props
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
) => jsx("div", _extends({}, props, {
  css: commonStyles,
  role: "presentation"
}));

/**
 * __Button indicator__
 *
 * An interactive indicator.
 */
export const ButtonIndicator = props => {
  return jsx(FocusRing, null, jsx("button", _extends({}, props, {
    role: "tab",
    type: "button",
    css: [commonStyles, buttonStyles]
  })));
};